import React from "react";
import styled from "styled-components";
import { style } from "./style";

export type TruncatedMultiLineTextProps = {
  lines: number;
  /**
   * The unit for `lineHeight` is em
   */
  lineHeight?: number;
  className?: string;
  as?: React.ElementType;
};

const Container = styled.div<{ $lines: number; $lineHeight: number }>`
  overflow: hidden;
  max-height: ${({ $lines, $lineHeight }) => `${$lines * $lineHeight}em`};
  line-height: ${({ $lineHeight }) => $lineHeight};
  display: -webkit-box; /* stylelint-disable-line value-no-vendor-prefix */
  display: -moz-box; /* stylelint-disable-line value-no-vendor-prefix */
  -webkit-box-orient: vertical; /* stylelint-disable-line property-no-vendor-prefix */
  -moz-box-orient: vertical; /* stylelint-disable-line property-no-vendor-prefix */
  -webkit-line-clamp: ${({ $lines }) => $lines}; /* stylelint-disable-line property-no-vendor-prefix */
`;

export const TruncatedMultiLineText: React.FC<TruncatedMultiLineTextProps> = ({
  lines,
  lineHeight = style.vars.lineHeight,
  className,
  as,
  children,
}) => {
  return (
    <Container as={as} $lines={lines} $lineHeight={lineHeight} className={className}>
      {children}
    </Container>
  );
};
